// extracted by mini-css-extract-plugin
module.exports = {"field":"_1JZ17e","editable":"t0-2go","text":"_1g6GFF","shine-lines":"_1U0i2M"};